import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// Must match ClientActionService.Api.Security.TokenPolicyAuthorizationFilter.ClientTokenHeaderName.
const CLIENT_TOKEN_HEADER = 'x-client-token';

export interface ResolveTokenResponse {
  expiresAt: string;
  instructions: string | null;
}

export interface VerifyIdentityChallenge {
  lastName: string;
  dateOfBirth: string; // YYYY-MM-DD
  phoneNumber: string;
}

export interface VerifyIdentityResponse {
  uploadToken: string | null;
  expiresAt: string | null;
}

export interface UploadFileResponse {
  success: boolean;
}

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  resolveToken(token: string): Observable<ResolveTokenResponse> {
    return this.http.post<ResolveTokenResponse>(`${this.baseUrl}/resolve?token=${encodeURIComponent(token)}`, null);
  }

  verifyIdentity(token: string, challenge: VerifyIdentityChallenge): Observable<VerifyIdentityResponse> {
    return this.http.post<VerifyIdentityResponse>(
      `${this.baseUrl}/verify`,
      { challenge },
      { headers: new HttpHeaders({ [CLIENT_TOKEN_HEADER]: token }) },
    );
  }

  uploadFile(uploadToken: string, file: File): Observable<UploadFileResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<UploadFileResponse>(
      `${this.baseUrl}/file`,
      formData,
      { headers: new HttpHeaders({ [CLIENT_TOKEN_HEADER]: uploadToken }) },
    );
  }
}
